// src/hooks/useAssetActions.ts
import { useCallback } from 'react';
import { useAssetApi } from '../../api/useAssetApi';

// Defined outside the hook so it is shared across all components that use this hook
const recentRequests = new Set<string>();

export const useAssetActions = () => {
  const { reprocessAssetApi } = useAssetApi();

  const reprocessAsset = useCallback(async (pk: string, sk: string, target: string) => {
    const requestIdentifier = `${pk}-${target}`;

    if (recentRequests.has(requestIdentifier)) {
      console.log(`Reprocess already requested for ${requestIdentifier}.`);
      return;
    }

    try {
      recentRequests.add(requestIdentifier);

      setTimeout(() => {
        recentRequests.delete(requestIdentifier);
      }, 30000);

      await reprocessAssetApi({ pk, sk, target });
      if (target !== 'thumbnails') {
        alert(`Reprocessing for ${target} started.`);
      }

    } catch (error: any) {
      console.error("Reprocess Error:", error);

      if (error.response?.status === 423) {
        alert("Asset is currently locked. Please try again in a few minutes.");
      } else {
        alert("Failed to trigger reprocessing.");
      }

      // Allow retry on failure
      recentRequests.delete(requestIdentifier);
    }
  }, [reprocessAssetApi]);

  return { reprocessAsset };
};